import { ImageCarousel } from '../../../components/imagecarousel/imagecarousel'

document.querySelectorAll('.cmp-image-carousel').forEach(element => new ImageCarousel(element as HTMLDivElement))
document.querySelectorAll('.cmp-pagestage-product__container-image-wrapper').forEach(element => new ImageCarousel(element as HTMLDivElement, true))
